
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getSubscriptionStatus } from '../api/axios.js';
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  //const [user, setUser] = useState(null);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  const contextLogin = (userData) => {
    setUser(userData);
  };

  const contextLogout = () => {
    setUser(null);
  };

  const refreshSubscription = async () => {
    if (!user) return;
    
    try {
      const response = await getSubscriptionStatus();
      
      // Only update if there's a change in subscription details
      if (response.data.planType !== user.data.planType) {
        
        setUser({
          ...user,
          data: {
            ...user.data,
            planType: response.data.planType,
            stripeCustomerId: response.data.stripeCustomerId
          }
        });
      }
    } catch (error) {
      console.error('Error refreshing subscription:', error);
    }
  };

  return (
    <UserContext.Provider value={{ user, contextLogin, contextLogout, refreshSubscription }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};